<template>
  <div class="main_address" :class="{ 'dark-mode': isDarkMode }">
    <link rel="stylesheet" :href="themeLink" id="theme-stylesheet" />
    <div class="address-page">
      <div class="left_address" @click="handleGoBack">
        <img src="../../images/left_arrowd.png" alt="Back Button" class="back-button" />
        <span class="text">Back</span>
      </div>
      <div class="rectangle_add_images">
        <img src="../../images/rectangle.png" alt="rectangles" />
      </div>
      <div class="content">
        <h2>
          Connect<br />
          Data Logger
        </h2>
      </div>
    </div>
    <div class="inverter_image" v-if="!showScanner">
      <img src="../../images/newLogger1.png" alt="logger" class="tri_logger" />
      <div class="left_arrow_image">
        <img src="../../images/left_arrow.png" alt="left arrow" />
      </div>
    </div>
    <div class="label" v-if="!showScanner">
      <p>
        QR can be seen on the data <br />
        logger. Scan to view details.
      </p>
    </div>
    <div class="button-container" v-if="!showScanner">
      <button class="scan-button" @click="toggleScanner">Scan Now</button>
    </div>
    <div style="margin-top: 10px;" v-if="!showScanner">
      <button class="show_me" @click="showPopup = true">Show me what to scan</button>
    </div>
    <div v-if="showScanner" class="modal-overlay">
      <div class="modal-content">
        <img src="../../images/close.png" alt="Close QR Scanner" class="close-icon" @click="toggleScanner">
        <div class="qr-scanner-box">
          <StreamBarcodeReader
            @decode="onDecode"
            @loaded="onLoaded"
            @init="onInit"
          ></StreamBarcodeReader>
        </div>
        <p class="scan-text">Label can be seen on the panel <br> Scan to view Logger details.</p>
        <input type="file" accept="image/*" @change="uploadImage" class="file-input" id="file-input" />
        <label for="file-input" class="upload-button">Upload from Gallery</label>
      </div>
    </div>
    <div v-if="showPopup" class="modal-overlay">
      <div class="modal-content">
        <img src="../../images/close.png" alt="Close Popup" class="close-icon" @click="showPopup = false">
        <img src="../../images/scanner_image.jpg" alt="Logger" class="modal-image">
        <p>Here's where you can find the QR code to scan.</p>
      </div>
    </div>
    <div v-if="combinedData" class="logger-details">
      <h3>Combined Details</h3>
      <p><strong>Inverter Model:</strong> {{ combinedData.inverter.model }}</p>
      <p><strong>Inverter Capacity:</strong> {{ combinedData.inverter.capacity }}</p>
      <p><strong>Inverter Brand:</strong> {{ combinedData.inverter.brand }}</p>
      <p><strong>Logger Serial Number:</strong> {{ combinedData.logger.serialNumber }}</p>
    </div>
  </div>
</template>

<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
import { mapActions, mapGetters } from 'vuex';
import jsQR from 'jsqr';
import { useToast } from 'vue-toastification';
import SiteService from "@/services/site.service";

export default {
  components: {
    StreamBarcodeReader
  },
  setup() {
    const toast = useToast();
    const toastOptions = {
      timeout: 1000, 
    };
    return { toast ,toastOptions };
  },
  data() {
    return {
      showScanner: false,
      showPopup: false,
      userMediaSupported: true,
      isDarkMode: false,
      combinedData: null, 
    };
  },
  computed: {
    ...mapGetters(['getLoggerData', 'getInverterData', 'getCombinedData']),
    themeLink() {
      return this.isDarkMode ? "/dark-theme.css" : "";
    },
    combinedData() {
      return this.getCombinedData;
    }
  },
  async mounted() {
    this.combinedData = null; 
    const savedDarkMode = localStorage.getItem("darkMode");
    if (savedDarkMode === "true") {
      this.isDarkMode = true;
    }
    this.applyDarkMode();
  },
  methods: {
    applyDarkMode() {
      const themeLinkElement = document.getElementById("theme-stylesheet");
      if (themeLinkElement) {
        themeLinkElement.href = this.themeLink;
      } else {
        console.error("Theme stylesheet link element not found");
      }
      document.body.classList.toggle("dark-mode", this.isDarkMode);
    },
    handleGoBack() {
      this.$router.go(-1);
    },
    ...mapActions(['saveLoggerData', 'saveCombinedData']),
    toggleScanner() {
      console.log("Toggling scanner visibility");
      if (this.userMediaSupported) {
        this.showScanner = !this.showScanner;
        if (this.showScanner) {
          console.log("Scanner opened");
        } else {
          console.log("Scanner closed");
        }
      } else {
        this.toast.error('Camera access is not supported or denied.', this.toastOptions);
      }
    },
    async onDecode(decodedText) {
      console.log(`Decoded text from QR code is ${decodedText}`);
      const urlParts = decodedText.split('/');
      const serialNumber = urlParts[urlParts.length - 1];
      const loggerData = {
        serialNumber: serialNumber
      };

      const inverterData = this.getInverterData;
      const combinedData = {
        inverter: inverterData,
        logger: loggerData,
      };
      this.combinedData = combinedData; 
      this.saveCombinedData(combinedData);
      if (loggerData.serialNumber) {
        try {
          const response = await SiteService.addDevice(combinedData);
          console.log('Response from addDevice:', response);
          if (response && response.id) {
            this.toast.success('Device added successfully.', this.toastOptions);
            setTimeout(() => {
            // this.$router.push('/scanqr');
              //  this.$router.push('/sitesummary');
          }, 2000);
            this.$router.push('/added');
          } else {
            this.toast.error('Error adding device.', this.toastOptions);
          }
        } catch (error) {
          console.error('Error adding device', error);
          this.toast.error('Error adding device', this.toastOptions);
        }
      } else {
        this.toast.error('Invalid QR code', this.toastOptions);
      }
    },
    onLoaded() {
      console.log('QR scanner is ready to start scanning barcodes');
    },
    onInit(promise) {
      console.log("Initializing QR scanner");
      promise
        .then(() => {
          this.userMediaSupported = true;
          console.log("QR scanner initialized successfully");
        })
        .catch(error => {
          console.error('Error initializing QR scanner', error);
          this.userMediaSupported = false;
          if (error.name === 'NotAllowedError') {
            this.toast.error('Camera access was denied.');
          } else if (error.name === 'NotFoundError') {
            this.toast.error('No camera found.');
          } else {
            this.toast.error(`Error initializing QR scanner: ${error.message}`);
          }
        });
    },
    uploadImage(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;
            context.drawImage(img, 0, 0, img.width, img.height);
            const imageData = context.getImageData(0, 0, img.width, img.height);
            const code = jsQR(imageData.data, imageData.width, imageData.height);
            if (code) {
              this.onDecode(code.data);
            } else {
              this.toast.error('No QR code found in the image.', this.toastOptions);
            }
          };
        };
        reader.readAsDataURL(file);
      }
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap");

body {
  font-family: "Montserrat", sans-serif;
}

.address-page {
  max-width: 100%;
  height: 30vh;
  margin: auto;
  border-bottom-left-radius: 35px;
  border-bottom-right-radius: 35px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  background: linear-gradient(to right, #050011, #120b41);
  overflow-x: hidden;
  position: relative;
  padding: 20px;
}

.left_address{
  display:flex;
  align-items:center;
  gap:5px;
  color:#fff;
  font-family: 'Montserrat';
font-size: 14px;
}

.back-button{
  height: 18px;
}

.rectangle_add_images {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}

.rectangle_add_images img {
  height: 200px;
  width: 336px;
}

.content {
  position: absolute;
  top: 30%;
  left: 28px;
  color: white;
  text-align: left;
}

h2 {
  font-family: "Montserrat";
  font-weight: 700;
  font-size: 30px;
  line-height: 1.2;
  margin-top: 22px;
}

.show {
  font-size: 12px;
  font-family: "Montserrat";
}
.tri_logger{
  height: auto;
  width: 200px;
}
.inverter_image {
  position: relative;
  margin-top: 50px;
  left: -5px;
}

.inverter_image img {
  object-fit: contain;

}

.left_arrow_image {
  position: absolute;
  top: 76%;
  left: 63%;
}

.label {
  font-size: 12px;
  font-family: "Montserrat";
  padding: 10px;
}

.label p {
  margin-right: 25%;
}

.button-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.scan-button {
  background-color: #453a94;
  border: none;
  color: white;
  padding: 9px 50px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  font-family: "Montserrat";
  width: 65%;
  margin-top: 45px;
}

.show_me {
  background-color: #F4F4F4;
  border: none;
  color: #453a94;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  font-family: "Montserrat";
  width: 65%;
  margin: auto;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal-content {
  position: relative;
  background-color: white;
  padding: 40px 22px;
  border-radius: 20px;
  border: 4px solid white;
  background-clip: padding-box;
  width: 80%;
  max-width: 500px;
  text-align: center;
}

.qr-scanner-box {
  border: 4px solid white;
  width: 250px;
  height: 250px;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  border-radius: 20px;
  overflow: hidden; 
}

.qr-scanner-box video {
  width: 100%;
  height: 100%;
  object-fit: cover; 
}

.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.modal-image {
  max-width: 100%;
  height: auto;
  margin-bottom: 20px;
}

.modal p {
  font-family: "Montserrat";
  font-size: 14px;
}

.scan-text {
  color: #000000;
  margin-top: 20px;
  font-size: 12px;
  font-family: "Montserrat";
  text-align: center;
}

.file-input {
  display: none;
}

.upload-button {
  /* margin-top: 20px; */
  display: block;
  width: 100%;
  padding: 10px;
  background-color: #453a94;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  font-family: "Montserrat";
  text-align: center;
}
.logger-details{
  margin: 20px;
  padding: 10px;
  background-color: #f4f4f4;
  border-radius: 5px;
}
</style>

